import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Power.css";
import {
  FaBook,
  FaFlask,
  FaRegChartBar,
  FaUsers,
  FaUsersCog,
} from "react-icons/fa";
import { RiComputerLine } from "react-icons/ri";

export default function Power() {
  return (
    <div>
      <Container className="power-margin">
        <h2>The power of learning with Hub Educational</h2>
        <p>
          Effortlessly upskill and train your workforce with a flexible
          platform.
        </p>
        <Row>
          <Col lg={4}>
            <h5>
              <FaBook /> 1,000s of courses
            </h5>
            <p1>
              In-demand courses and stackable credentials ensure employee
              learning is aligned with business goals.
            </p1>
          </Col>
          <Col lg={4}>
            <h5>
              <RiComputerLine /> World-class content
            </h5>
            <p1>
              Expert instruction from the world’s leading universities and
              companies using courses designed to promote active, deep learning.
            </p1>
          </Col>
          <Col lg={4}>
            <h5>
              <FaFlask /> Informed by science
            </h5>
            <p1>
              Using the findings of the McGovern Brain Institute, Hub
              Educational courses motivate and engage learners to maximize
              long-term learning benefits.
            </p1>
          </Col>
          <Col lg={4}>
            <h5>
              <FaUsers /> Social Learning
            </h5>
            <p1>
              Private cohorts facilitate inter-company learning and real-world
              applications
            </p1>
          </Col>
          <Col lg={4}>
            <h5>
              <FaRegChartBar /> Actionable data
            </h5>
            <p1>
              Administration and learner dashboards provide insight into learner
              progress while helping admins manage their program. White glove
              services Solve employee skills gaps with pathways and resources
              that promote employee adoption and
            </p1>
          </Col>
          <Col lg={4}>
            <h5>
              <FaUsersCog /> White glove services
            </h5>
            <p1>
              Solve employee skills gaps with pathways and resources that
              promote employee adoption and engagement.
            </p1>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
